<template>
  <v-dialog v-model="dialog_open" max-width="500">
    <v-card-text style="background-color: #fff">
      <v-card-title class="py-3 white--text" value="tab-1">
        <span
          class="ml-3 font-weight-bold font-30 text-000000 font-sarabun"
          style="color: #000"
        >
          ยืนยันการจัดส่งยา
        </span>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog_open = false" style="text-align: right">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
      </v-card-title>
      <div>
        <v-row>
          <v-col cols="12" v-if="radio == 1">
            <v-img
              style="margin-left: auto; margin-right: auto"
              width="110px"
              height="110px"
              :src="require('@/assets/icon/check-circle 2.png')"
            ></v-img>
          </v-col>
          <v-col cols="12">
            <span
              class="ml-3 font-weight-bold font-24 text-000000 font-sarabun d-flex justify-center"
            >
              ยืนยันการจัดส่งยา
            </span>
          </v-col>
        </v-row>
      </div>
      <!-- <v-row>
        <v-col cols="12">
          <span
            class="ml-3 font-weight-bold font-24 text-000000 font-sarabun d-flex justify-center"
          >
            เลือกช่องทางการจัดส่งยา
          </span>
        </v-col>
      </v-row>
      <div>
        <v-container class="d-flex justify-center">
          <v-card-text>
            <v-radio-group v-model="radio">
              <v-radio
                class="ml-3 font-weight-bold font-30 text-000000 font-sarabun"
                label="ให้ผู้ป่วยเลือกวิธีการรับยาเอง"
                :value="2"
              ></v-radio>
              <v-radio
                class="ml-3 font-weight-bold font-30 text-000000 font-sarabun"
                label="ให้ผู้ป่วยรับยาที่ร้านยาใกล้บ้าน"
                :value="3"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-container>
        <v-container class="d-flex justify-center" v-model="radio">
          <v-row class="pb-5 d-flex justify-center align-center">
            <v-col cols="10" v-if="radio == 3">
              <v-card elevation="0">
                <v-combobox
                  label="เลือกร้านยา"
                  v-model="dataItem"
                  :items="drug_store"
                  item-value="pharmacy_id"
                  item-text="pharmacy_name"
                  variant="underlined"
                  clearable
                  required
                  class="ml-3 font-weight-bold font-30 text-000000 font-sarabun"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
                    </v-list-item>
                  </template>
                  <template slot="selection" slot-scope="{ item }">
                    <span>{{ item.pharmacy_name }} </span>
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    <div class="d-flex flex-column">
                      <span>{{ item.pharmacy_name }} </span>
                    </div>
                  </template>
                </v-combobox>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div> -->
      <v-form v-model="radio_form">
        <v-card-actions>
          <v-row class="pa-0 ma-0">
            <v-col cols="12" sm="6">
              <v-btn
                color="#1CA7B4"
                dark
                outlined
                width="100%"
                height="48px"
                @click="close"
              >
                ยกเลิก
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn
                color="#1CA7B4"
                dark
                width="100%"
                height="48px"
                @click="
                  dialog_open = false;
                  confirmEdit();
                "
              >
                ยืนยัน
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";
export default {
  data: () => ({
    dialog_open: false,
    sendEdit: "",
    radio: "1",
    radio_form: false,
    choose_pharmacy: false,
    drug_store: [],
    dataItem: {
      pharmacy_address: "",
      pharmacy_id: "",
      pharmacy_name: "",
    },
    dentist_clinic_id: sessionStorage.dentist_clinic_id,
    biz_id: sessionStorage.biz_id,
  }),
  // mounted() {
  //   this.getDrugstore();
  // },
  computed: {
    ...mapState(["appointmentDetail"]),
  },
  methods: {
    openDialog(item) {
      const { time_slot_dentist_id } = item;
      this.time_slot_dentist_id = time_slot_dentist_id;
      this.dialog_open = true;
      this.radio = true;
      this.radio_form = true
    },
    close() {
      this.dialog_open = false;
      this.$emit("close");
    },
    // getDrugstore() {
    //   try {
    //     this.axios
    //       .get(`${process.env.VUE_APP_BASE_URL}/pharmacy?dentist_clinic_id=06`)
    //       .then(async (res) => {
    //         await this.$store.dispatch("actionLog", {
    //           action: "get pharmacy",
    //           action_by: sessionStorage.account_id,
    //           path: `/pharmacy`,
    //           params: {
    //             dentist_clinic_id: "06",
    //           },
    //         });
    //         this.drug_store = res.data.result;
    //       });
    //   } catch (e) {
    //     alert(e);
    //   }
    // },
    async confirmEdit() {
      try {
        await this.axios
          .put(`${process.env.VUE_APP_BACKEND_URL}/v1/drug-status`, {
            appointment_id: this.appointmentDetail.appointment_id,
            status_drug: "confirm",
            pharmacist_id: sessionStorage.account_id,
            pharmacist_name: sessionStorage.accountName,
          })
          .then((res) => {
            console.log(res);
            if (res.data.result === "success") {
              // .put(
              //   `${process.env.VUE_APP_BASE_URL}/drug/update-status?time_slot_dentist_id=${this.time_slot_dentist_id}`,
              //   dataBody
              // )
              // .then(async (res) => {
              //   await this.$store.dispatch("actionLog", {
              //     action: "update drug status",
              //     action_by: sessionStorage.account_id,
              //     path: `/drug/update-status`,
              //     params: {
              //       time_slot_dentist_id: this.time_slot_dentist_id,
              //     },
              //     body: dataBody,
              //   });
              //   const { data: { message } = {} } = res;
              //   if (message === "success") {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "ส่งยาสำเร็จ",
                showConfirmButton: false,
                timer: 2000,
              });
              this.close();
            }
          });
      } catch (error) {
        console.error();
        Swal.fire({
          position: "center",
          icon: "error",
          title: "ส่งยาไม่สำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        });
      }
      this.close();
    },
  },
};
</script>

<style>
::v-deep .v-label {
  font-size: 20em;
}
::v-deep .v-label--active {
  font-size: 20em;
  font-weight: bold;
}
</style>
